import { Link } from "react-router-dom";
import { Clock, Instagram, Mail, MapPin, MessageCircle, Phone } from "lucide-react";
import { CONTACTS, STORES, waLink } from "@/lib/constants";
import { useTexts } from "@/lib/texts";

export default function Footer() {
  const texts = useTexts();
  return (
    <footer className="relative overflow-hidden border-t border-white/10 bg-[#030303]" data-testid="footer">
      <div className="mx-auto max-w-7xl px-5 pt-16 md:px-8 md:pt-24">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-4">
            <div className="flex items-center">
              <img src="/assets/logo-gold.png" alt="Oro Jewels — Gioielli & Orologi" className="h-12 w-auto" />
            </div>
            <p className="mt-4 font-serif text-lg italic text-[#A3A3A3]" data-testid="footer-tagline">{texts.footer_tagline}</p>
            <div className="mt-6 flex gap-3">
              <a
                href={CONTACTS.instagram}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram-link"
                aria-label="Instagram"
                className="flex h-10 w-10 items-center justify-center border border-white/15 text-[#A3A3A3] transition-colors duration-300 hover:border-gold hover:text-gold"
              >
                <Instagram size={16} />
              </a>
              <a
                href={waLink("Buongiorno, vorrei informazioni.")}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp-link"
                aria-label="WhatsApp"
                className="flex h-10 w-10 items-center justify-center border border-white/15 text-[#A3A3A3] transition-colors duration-300 hover:border-gold hover:text-gold"
              >
                <MessageCircle size={16} />
              </a>
              <a
                href={`mailto:${CONTACTS.email}`}
                data-testid="footer-email-link"
                aria-label="Email"
                className="flex h-10 w-10 items-center justify-center border border-white/15 text-[#A3A3A3] transition-colors duration-300 hover:border-gold hover:text-gold"
              >
                <Mail size={16} />
              </a>
            </div>
          </div>

          <div className="md:col-span-5">
            <h4 className="text-[10px] uppercase tracking-[0.35em] text-[#A3A3A3]">I nostri negozi</h4>
            <ul className="mt-5 space-y-5">
              {STORES.map((s) => (
                <li key={s.id} data-testid={`footer-store-${s.id}`}>
                  <p className="font-serif text-base text-[#FAFAFA]">{s.name}</p>
                  <p className="mt-1 flex items-center gap-2 text-sm text-[#A3A3A3]">
                    <MapPin size={13} className="text-gold/70" /> {s.address}, {s.zip}
                  </p>
                  <a
                    href={`tel:${s.tel}`}
                    data-testid={`footer-store-${s.id}-phone`}
                    className="mt-1 flex items-center gap-2 text-sm text-[#A3A3A3] transition-colors hover:text-gold"
                  >
                    <Phone size={13} className="text-gold/70" /> {s.phone}
                  </a>
                  {s.hours && (
                    <p className="mt-1 flex items-start gap-2 text-xs leading-relaxed text-[#737373]" data-testid={`footer-store-${s.id}-hours`}>
                      <Clock size={12} className="mt-0.5 shrink-0 text-gold/70" />
                      <span>
                        {s.hours.map((h) => (
                          <span key={h} className="block">{h}</span>
                        ))}
                      </span>
                    </p>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-[10px] uppercase tracking-[0.35em] text-[#A3A3A3]">Esplora</h4>
            <ul className="mt-5 space-y-3 text-sm">
              {[
                ["/catalogo", "Catalogo"],
                ["/storia", "La nostra storia"],
                ["/novita", "Novità"],
                ["/contatti", "Contatti"],
              ].map(([to, label]) => (
                <li key={to}>
                  <Link
                    to={to}
                    data-testid={`footer-link-${label.toLowerCase().replace(/\s/g, "-")}`}
                    className="text-[#A3A3A3] transition-colors duration-300 hover:text-gold"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
            <p className="mt-8 text-sm text-[#A3A3A3]">
              <a href={`mailto:${CONTACTS.email}`} className="transition-colors hover:text-gold">{CONTACTS.email}</a>
            </p>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-center justify-between gap-3 border-t border-white/10 py-6 text-[11px] uppercase tracking-[0.25em] text-[#666] sm:flex-row">
          <p>© {new Date().getFullYear()} Oro Jewels · Compro oro Milano e Monza</p>
          <a href={CONTACTS.instagram} target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-gold">
            {CONTACTS.instagramHandle}
          </a>
        </div>
      </div>
    </footer>
  );
}
